/* ============================================================
   header-footer.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    const $ = (s, ctx = document) => ctx.querySelector(s);
    const $$ = (s, ctx = document) => Array.from(ctx.querySelectorAll(s));

    const header = $(".site-header");
    const toggleBtn = $(".nav__toggle");
    const nav = $("#primary-nav");
    const searchBtn = $(".icon-btn.search");
    const searchOverlay = $("#site-search");
    const searchClose = $(".search-close");

    if (toggleBtn && nav) {
        toggleBtn.addEventListener("click", () => {
            header.classList.toggle("nav--open");

            const isOpen = nav.classList.toggle("is-open");
            toggleBtn.setAttribute("aria-expanded", isOpen);

            if (isOpen) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        });
    }

    $$(".nav__mobile-arrow").forEach(arrow => {
        arrow.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            const parentLi = arrow.closest(".has-dropdown");
            parentLi.classList.toggle("is-active");
        });
    });

    if (searchBtn && searchOverlay) {
        searchBtn.addEventListener("click", () => {
            searchOverlay.classList.add("is-open");
            searchOverlay.querySelector("input")?.focus();
        });

        searchClose?.addEventListener("click", () => {
            searchOverlay.classList.remove("is-open");
        });

        const searchForms = $$('.search-form, .nav__mobile-search');
        searchForms.forEach(form => {
            form.addEventListener('submit', () => {
                searchOverlay.classList.remove("is-open");

                if (nav && nav.classList.contains("is-open")) {
                    nav.classList.remove("is-open");
                    header.classList.remove("nav--open");
                    toggleBtn.setAttribute("aria-expanded", false);
                    document.body.style.overflow = "";
                }
            });
        });
    }

    window.addEventListener("scroll", () => {
        if (header) header.classList.toggle("is-scrolled", window.scrollY > 10);
    });
});


/* ============================================================
   hero-carousel.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.hero[data-module="hero-carousel"]');
    if (!section) return;

    const charLimit = 220;
    const texts = section.querySelectorAll('.hero__sub');

    texts.forEach(text => {
        const originalText = text.textContent.trim();
        if (originalText.length > charLimit) {
            text.textContent = originalText.substring(0, charLimit) + '...';
        }
    });

    section.classList.add('is-visible');

    const viewport = section.querySelector('.hero__viewport');
    const track = section.querySelector('.hero__track');

    const slides = Array.from(section.querySelectorAll('.hero__slide'));
    const prev = section.querySelector('.hero__arrow.prev');
    const next = section.querySelector('.hero__arrow.next');
    const pagerWrap = section.querySelector('.pager__pages');
    const controls = section.querySelector('.hero__controls');

    if (slides.length <= 1) {
        if (controls) controls.style.display = 'none';
        return;
    }

    const mqMobile = window.matchMedia('(max-width:900px)');
    let currentIndex = 0;

    function buildPager() {
        pagerWrap.innerHTML = '';
        slides.forEach((_, i) => {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = String(i + 1);
            btn.setAttribute('aria-label', 'Go to hero slide ' + (i + 1));
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                goTo(i);
            });
            li.appendChild(btn);
            pagerWrap.appendChild(li);
        });
        updatePager();
    }

    function updatePager() {
        const buttons = pagerWrap.querySelectorAll('button');
        buttons.forEach((btn, idx) => {
            if (idx === currentIndex) {
                btn.setAttribute('aria-current', 'page');
            } else {
                btn.removeAttribute('aria-current');
            }
        });
    }

    function nearestMobileIndex() {
        const l = viewport.scrollLeft;
        let nearest = 0;
        let min = Infinity;

        slides.forEach((slide, idx) => {
            const d = Math.abs(slide.offsetLeft - l);
            if (d < min) {
                min = d;
                nearest = idx;
            }
        });
        return nearest;
    }

    function goTo(index) {
        if (index < 0) index = 0;
        if (index >= slides.length) index = slides.length - 1;

        currentIndex = index;

        if (mqMobile.matches) {
            const target = slides[currentIndex];
            viewport.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
        } else {
            const slideWidth = slides[0].getBoundingClientRect().width;
            track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;
        }

        updatePager();
    }

    if (prev) {
        prev.addEventListener('click', () => {
            if (mqMobile.matches) currentIndex = nearestMobileIndex();
            goTo(currentIndex - 1);
        });
    }

    if (next) {
        next.addEventListener('click', () => {
            if (mqMobile.matches) currentIndex = nearestMobileIndex();
            goTo(currentIndex + 1);
        });
    }

    viewport.addEventListener('scroll', function () {
        if (!mqMobile.matches) return;

        const newIndex = nearestMobileIndex();
        if (newIndex !== currentIndex) {
            currentIndex = newIndex;
            updatePager();
        }
    });

    window.addEventListener('resize', () => {
        if (mqMobile.matches) {
            track.style.transform = 'none';
        } else {
            goTo(currentIndex);
        }
    });

    buildPager();
});


/* ============================================================
   news-archive.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    const filterBtn = document.querySelector('.news-filter__toggle');
    const filterMenu = document.getElementById('news-filter-dropdown');

    if (filterBtn && filterMenu) {

        filterBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            const isExpanded = filterBtn.getAttribute('aria-expanded') === 'true';

            if (isExpanded) {
                closeFilter();
            } else {
                openFilter();
            }
        });

        document.addEventListener('click', function (e) {
            if (!filterBtn.contains(e.target) && !filterMenu.contains(e.target)) {
                closeFilter();
            }
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                closeFilter();
            }
        });

        function openFilter() {
            filterBtn.setAttribute('aria-expanded', 'true');
            filterMenu.hidden = false;
            setTimeout(() => {
                filterMenu.classList.add('is-open');
            }, 10);
        }

        function closeFilter() {
            filterBtn.setAttribute('aria-expanded', 'false');
            filterMenu.classList.remove('is-open');
            setTimeout(() => {
                filterMenu.hidden = true;
            }, 200);
        }
    }
});


/* ============================================================
   news-carousel.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.section.news-carousel');
    if (!section) return;

    section.classList.add('is-visible');

    const grid = section.querySelector('.cards--news');
    let track = section.querySelector('.news-carousel__track');
    if (!track) track = grid;

    const cards = grid ? Array.from(grid.querySelectorAll('.news-card')) : [];
    const prev = section.querySelector('.news-carousel__arrow.prev');
    const next = section.querySelector('.news-carousel__arrow.next');
    const pagerWrap = section.querySelector('.pager__pages');

    if (!grid || cards.length === 0 || !pagerWrap) return;

    const mqMobile = window.matchMedia('(max-width:960px)');
    let desktopIndex = 0;

    function buildPager(count) {
        pagerWrap.innerHTML = '';
        for (let i = 0; i < count; i++) {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = String(i + 1);
            btn.setAttribute('aria-label', 'Go to news slide ' + (i + 1));
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                goTo(i);
            });
            li.appendChild(btn);
            pagerWrap.appendChild(li);
        }
    }

    function setCurrent(i) {
        const buttons = pagerWrap.querySelectorAll('button');
        buttons.forEach((btn, idx) => {
            if (idx === i) {
                btn.setAttribute('aria-current', 'page');
            } else {
                btn.removeAttribute('aria-current');
            }
        });
    }

    function nearestMobileIndex() {
        const scroller = mqMobile.matches ? grid : track;
        const l = scroller.scrollLeft;
        let nearest = 0;
        let min = Infinity;

        cards.forEach((card, idx) => {
            const d = Math.abs(card.offsetLeft - l);
            if (d < min) {
                min = d;
                nearest = idx;
            }
        });

        return nearest;
    }

    function updateDesktop() {
        setCurrent(desktopIndex);
    }

    function goTo(i) {
        if (mqMobile.matches) {
            const idx = Math.max(0, Math.min(i, cards.length - 1));
            const target = cards[idx];
            grid.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
            setCurrent(idx);
        } else {
            if (!track) return;

            const pageWidth = grid.clientWidth + 32;
            const maxSlide = Math.ceil(cards.length / 3) - 1;

            desktopIndex = Math.max(0, Math.min(i, maxSlide));
            track.style.transform = `translateX(-${desktopIndex * pageWidth}px)`;

            setCurrent(desktopIndex);
        }
    }

    function onResize() {
        if (mqMobile.matches) {
            track.style.transform = 'none';
            buildPager(cards.length);
            setCurrent(nearestMobileIndex());
        } else {
            const pageCount = Math.ceil(cards.length / 3) || 1;
            buildPager(pageCount);

            if (desktopIndex >= pageCount) desktopIndex = 0;

            const pageWidth = grid.clientWidth + 32;
            track.style.transform = `translateX(-${desktopIndex * pageWidth}px)`;

            updateDesktop();
        }
    }

    if (prev) {
        prev.addEventListener('click', function () {
            if (mqMobile.matches) {
                goTo(nearestMobileIndex() - 1);
            } else {
                goTo(desktopIndex - 1);
            }
        });
    }

    if (next) {
        next.addEventListener('click', function () {
            if (mqMobile.matches) {
                goTo(nearestMobileIndex() + 1);
            } else {
                goTo(desktopIndex + 1);
            }
        });
    }

    grid.addEventListener('scroll', function () {
        if (!mqMobile.matches) return;
        setCurrent(nearestMobileIndex());
    });

    onResize();
    window.addEventListener('resize', onResize);
});


/* ============================================================
   quicklinks.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.section.quicklinks[data-module="quicklinks-carousel"]');
    if (!section) return;

    section.classList.add('is-visible');

    const grid = section.querySelector('.quicklinks__viewport');
    const track = section.querySelector('.quicklinks__track');
    const cards = Array.from(track.querySelectorAll('.quicklinks-card'));

    const prev = section.querySelector('.quicklinks__arrow.prev');
    const next = section.querySelector('.quicklinks__arrow.next');
    const pagerWrap = section.querySelector('.pager__pages');
    const controls = section.querySelector('.quicklinks__controls');

    if (!track || cards.length === 0) return;

    // ===========================================================
    // TEXT TRUNCATION (160 characters)
    // ===========================================================
    const charLimit = 160;
    const textElements = section.querySelectorAll('.quicklinks-card__text');

    textElements.forEach(paragraph => {
        const originalText = paragraph.textContent.trim();
        if (originalText.length > charLimit) {
            // Find last space to avoid cutting mid-word
            let truncated = originalText.substring(0, charLimit);
            const lastSpace = truncated.lastIndexOf(' ');

            if (lastSpace > 0) {
                truncated = truncated.substring(0, lastSpace);
            }

            paragraph.textContent = truncated + '...';
        }
    });

    const mqMobile = window.matchMedia('(max-width:960px)');
    let desktopIndex = 0;

    function buildPager(count) {
        pagerWrap.innerHTML = '';
        for (let i = 0; i < count; i++) {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = String(i + 1);
            btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                goTo(i);
            });
            li.appendChild(btn);
            pagerWrap.appendChild(li);
        }
    }

    function setCurrent(i) {
        const buttons = pagerWrap.querySelectorAll('button');
        buttons.forEach((btn, idx) => {
            if (idx === i) {
                btn.setAttribute('aria-current', 'page');
            } else {
                btn.removeAttribute('aria-current');
            }
        });
    }

    function nearestMobileIndex() {
        const scroller = mqMobile.matches ? grid : track;
        const l = scroller.scrollLeft;
        let nearest = 0;
        let min = Infinity;

        cards.forEach((card, idx) => {
            const d = Math.abs(card.offsetLeft - l);
            if (d < min) {
                min = d;
                nearest = idx;
            }
        });
        return nearest;
    }

    function goTo(i) {
        if (mqMobile.matches) {
            const idx = Math.max(0, Math.min(i, cards.length - 1));
            const target = cards[idx];
            grid.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
            setCurrent(idx);
        } else {
            const pageWidth = grid.clientWidth + 32;
            const maxSlide = Math.ceil(cards.length / 3) - 1;
            desktopIndex = Math.max(0, Math.min(i, maxSlide));
            track.style.transform = `translateX(-${desktopIndex * pageWidth}px)`;
            setCurrent(desktopIndex);
        }
    }

    function onResize() {
        if (mqMobile.matches) {
            track.style.transform = 'none';
            buildPager(cards.length);
            setCurrent(nearestMobileIndex());
        } else {
            const pageCount = Math.ceil(cards.length / 3) || 1;
            buildPager(pageCount);

            if (desktopIndex >= pageCount) desktopIndex = 0;

            const pageWidth = grid.clientWidth + 32;
            track.style.transform = `translateX(-${desktopIndex * pageWidth}px)`;

            setCurrent(desktopIndex);
        }
    }

    if (prev) {
        prev.addEventListener('click', function () {
            if (mqMobile.matches) {
                goTo(nearestMobileIndex() - 1);
            } else {
                goTo(desktopIndex - 1);
            }
        });
    }

    if (next) {
        next.addEventListener('click', function () {
            if (mqMobile.matches) {
                goTo(nearestMobileIndex() + 1);
            } else {
                goTo(desktopIndex + 1);
            }
        });
    }

    grid.addEventListener('scroll', function () {
        if (!mqMobile.matches) return;
        setCurrent(nearestMobileIndex());
    });

    onResize();
    window.addEventListener('resize', onResize);
});


/* ============================================================
   testimonials.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.section.testimonials');
    if (!section) return;

    // ===========================================================
    // 1. TEXT TRUNCATION LOGIC (Limit to 510 chars)
    // ===========================================================
    const charLimit = 510;
    const quotes = section.querySelectorAll('.quote-card blockquote');

    quotes.forEach(quote => {
        const originalText = quote.textContent.trim();
        if (originalText.length > charLimit) {
            // Trim to limit and add ellipsis
            quote.textContent = originalText.substring(0, charLimit) + '...';
        }
    });

    // ===========================================================
    // 2. CAROUSEL LOGIC
    // ===========================================================

    section.classList.add('is-visible');

    const grid = section.querySelector('.testimonials__viewport');
    let track = section.querySelector('.testimonials__track');

    // Fallback
    if (!track) track = grid;

    const cards = grid ? Array.from(grid.querySelectorAll('.quote-card')) : [];
    const prev = section.querySelector('.testimonials__arrow.prev');
    const next = section.querySelector('.testimonials__arrow.next');
    const pagerWrap = section.querySelector('.pager__pages');

    if (!grid || cards.length === 0 || !pagerWrap) return;

    const mqMobile = window.matchMedia('(max-width:960px)');
    let desktopIndex = 0;

    function buildPager(count) {
        pagerWrap.innerHTML = '';
        for (let i = 0; i < count; i++) {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = String(i + 1);
            btn.setAttribute('aria-label', 'Go to testimonial slide ' + (i + 1));
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                goTo(i);
            });
            li.appendChild(btn);
            pagerWrap.appendChild(li);
        }
    }

    function setCurrent(i) {
        const buttons = pagerWrap.querySelectorAll('button');
        buttons.forEach((btn, idx) => {
            if (idx === i) {
                btn.setAttribute('aria-current', 'page');
            } else {
                btn.removeAttribute('aria-current');
            }
        });
    }

    function nearestMobileIndex() {
        const scroller = mqMobile.matches ? grid : track;
        const l = scroller.scrollLeft;
        let nearest = 0;
        let min = Infinity;

        cards.forEach((card, idx) => {
            const d = Math.abs(card.offsetLeft - l);
            if (d < min) {
                min = d;
                nearest = idx;
            }
        });

        return nearest;
    }

    function updateDesktop() {
        setCurrent(desktopIndex);
    }

    function goTo(i) {
        if (mqMobile.matches) {
            // Mobile: scroll to a single card
            const idx = Math.max(0, Math.min(i, cards.length - 1));
            const target = cards[idx];
            grid.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
            setCurrent(idx);
        } else {
            // Desktop: Slide the track
            if (!track) return;

            // Matches News Logic: Width of container + 32px gap
            const pageWidth = grid.clientWidth + 32;

            const maxSlide = Math.ceil(cards.length / 3) - 1;

            desktopIndex = Math.max(0, Math.min(i, maxSlide));

            track.style.transform = `translateX(-${desktopIndex * pageWidth}px)`;

            setCurrent(desktopIndex);
        }
    }

    function onResize() {
        if (mqMobile.matches) {
            // Mobile state
            track.style.transform = 'none';
            buildPager(cards.length);
            setCurrent(nearestMobileIndex());
        } else {
            // Desktop state
            const pageCount = Math.ceil(cards.length / 3) || 1;
            buildPager(pageCount);

            if (desktopIndex >= pageCount) desktopIndex = 0;

            // Re-apply the desktop transform for the current index
            const pageWidth = grid.clientWidth + 32;
            track.style.transform = `translateX(-${desktopIndex * pageWidth}px)`;

            updateDesktop();
        }
    }

    // Arrow handlers
    if (prev) {
        prev.addEventListener('click', function () {
            if (mqMobile.matches) {
                goTo(nearestMobileIndex() - 1);
            } else {
                goTo(desktopIndex - 1);
            }
        });
    }

    if (next) {
        next.addEventListener('click', function () {
            if (mqMobile.matches) {
                goTo(nearestMobileIndex() + 1);
            } else {
                goTo(desktopIndex + 1);
            }
        });
    }

    // Sync pager with scroll on mobile
    grid.addEventListener('scroll', function () {
        if (!mqMobile.matches) return;
        setCurrent(nearestMobileIndex());
    });

    // Initial build + on resize
    onResize();
    window.addEventListener('resize', onResize);
});

/* ============================================================
featured pages (services grid)
============================================================ */

document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.section.services-grid');
    if (!section) return;

    // ===========================================================
    // 1. TEXT TRUNCATION
    // ===========================================================
    const charLimit = 150;
    const serviceCards = section.querySelectorAll('.card--service .card__body p');

    serviceCards.forEach(paragraph => {
        const originalText = paragraph.textContent.trim();
        if (originalText.length > charLimit) {
            paragraph.textContent = originalText.substring(0, charLimit) + '...';
        }
    });

    // ===========================================================
    // 2. FILLER CARD LOGIC (if needed)
    // ===========================================================
    const grid = section.querySelector('.services__grid');
    if (!grid) return;

    const cards = grid.querySelectorAll('.card--service');

    if (cards.length % 2 !== 0) {
        const template = document.getElementById('filler-card-template');
        if (template) {
            const clone = template.content.cloneNode(true);
            grid.appendChild(clone);
        }
    }
});